import React from "react";

import { Button, Menu, MenuItem, Typography } from "@material-ui/core";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import { withStyles } from "@material-ui/core/styles";

import Spacer from "components/Spacer";

import { useAppDispatch, useAppSelector } from "store";
import { selectUserInfo } from "modules/auth/authSlice";
import {
    selectOperatorsSort,
    setOperatorsSort,
    OperatorsSortField
} from "modules/customer/tools/product/partnerFilters/partnerFiltersSlice";
import { SortDirection } from "utils/sortUtils";

const StyledMenu = withStyles(theme => ({
    list: {
        width: theme.spacing(25)
    }
}))(Menu);

const StyledMenuItem = withStyles(theme => ({
    root: {
        fontWeight: (props: any) => props["data-current"] ? "bold" : "normal",
        color: (props: any) => props["data-current"] ? theme.palette.text.primary : theme.palette.text.disabled
    }
}))(MenuItem);

const Sort: React.FC = () => {
    const dispatch = useAppDispatch();
    const clientName = useAppSelector(selectUserInfo).companyDisplayName;
    const operatorsSort = useAppSelector(selectOperatorsSort);
    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSortClick = (field: OperatorsSortField) => () => {
        let direction = SortDirection.ASC;
        if (operatorsSort.field === field) {
            direction = operatorsSort.direction === SortDirection.ASC ? SortDirection.DESC : SortDirection.ASC;
        }
        const newOperatorsSort = { ...operatorsSort, field, direction };
        dispatch(setOperatorsSort(newOperatorsSort));
    };

    return (
        <>
            <Button
                variant="text"
                size="small"
                color="default"
                disableElevation
                startIcon={<ArrowDownwardIcon />}
                onClick={handleClick}
                data-cy="btn-sort"
            >
                Sort
            </Button>
            <StyledMenu
                open={open}
                onClose={handleClose}
                variant="menu"
                keepMounted
                anchorEl={anchorEl}
                getContentAnchorEl={null}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right"
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right"
                }}
            >
                <StyledMenuItem onClick={handleSortClick(OperatorsSortField.OperatorName)} data-current={operatorsSort.field === OperatorsSortField.OperatorName}>
                    <Typography variant="body1" component="div">
                        Operator name
                    </Typography>
                    <Spacer />
                    {operatorsSort.field !== OperatorsSortField.OperatorName || operatorsSort.direction === SortDirection.ASC ? (
                        <ArrowUpwardIcon fontSize="small" />
                    ) : (
                        <ArrowDownwardIcon fontSize="small" />
                    )}
                </StyledMenuItem>
                <StyledMenuItem onClick={handleSortClick(OperatorsSortField.Headroom)} data-current={operatorsSort.field === OperatorsSortField.Headroom}>
                    <Typography variant="body1" component="div">
                        Headroom
                    </Typography>
                    <Spacer />
                    {operatorsSort.field !== OperatorsSortField.Headroom || operatorsSort.direction === SortDirection.ASC ? (
                        <ArrowUpwardIcon fontSize="small" />
                    ) : (
                        <ArrowDownwardIcon fontSize="small" />
                    )}
                </StyledMenuItem>
                <StyledMenuItem onClick={handleSortClick(OperatorsSortField.OptimisedSales)} data-current={operatorsSort.field === OperatorsSortField.OptimisedSales}>
                    <Typography variant="body1" component="div">
                        Optimised sales
                    </Typography>
                    <Spacer />
                    {operatorsSort.field !== OperatorsSortField.OptimisedSales || operatorsSort.direction === SortDirection.ASC ? (
                        <ArrowUpwardIcon fontSize="small" />
                    ) : (
                        <ArrowDownwardIcon fontSize="small" />
                    )}
                </StyledMenuItem>
                <StyledMenuItem onClick={handleSortClick(OperatorsSortField.TotalEstimatedSales)} data-current={operatorsSort.field === OperatorsSortField.TotalEstimatedSales}>
                    <Typography variant="body1" component="div">
                        Estimated sales
                    </Typography>
                    <Spacer />
                    {operatorsSort.field !== OperatorsSortField.TotalEstimatedSales || operatorsSort.direction === SortDirection.ASC ? (
                        <ArrowUpwardIcon fontSize="small" />
                    ) : (
                        <ArrowDownwardIcon fontSize="small" />
                    )}
                </StyledMenuItem>
                <StyledMenuItem onClick={handleSortClick(OperatorsSortField.ClientSourcedSales)} data-current={operatorsSort.field === OperatorsSortField.ClientSourcedSales}>
                    <Typography variant="body1" component="div">
                        {clientName} sourced sales
                    </Typography>
                    <Spacer />
                    {operatorsSort.field !== OperatorsSortField.ClientSourcedSales || operatorsSort.direction === SortDirection.ASC ? (
                        <ArrowUpwardIcon fontSize="small" />
                    ) : (
                        <ArrowDownwardIcon fontSize="small" />
                    )}
                </StyledMenuItem>
            </StyledMenu>
        </>
    );
};

export default Sort;
